import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Typewriter from "typewriter-effect";

/* ---------- Universal helper component to ensure react router dom navs scroll to top as do href navs ---------- */
const Card = () => {

    const navigate = useNavigate();

    const [isTextTyping, setIsTextTyping] = useState(true);
    useEffect(() => {
        if (!isTextTyping) {
            setTimeout(() => {
                navigate('/beta/reviews');
            }, (750));
        }
    }, [isTextTyping]);

    return (
        <div class="w-full flex flex-col flex-1 max-w-7xl mx-auto p-4 items-center justify-center">
            {/* {readyForSplash && (
                <MooSplash />
            )} */}
            <div class="flex text-black w-full max-w-xl text-left sm:text-center items-center justify-center">
                <a className={`flex w-full text-xs text-left font-mono uppercase ${!isTextTyping && 'animate-slide-up-fade-out'}`}>
                    <Typewriter
                        options={{
                            delay: 36,
                            autoStart: true,
                            cursor: "_",
                            deleteSpeed: 18,
                        }}
                        onInit={(typewriter) => {
                            typewriter
                                .typeString("Dear Cow Juice Private Beta Tester: ")
                                .pauseFor(250)
                                .typeString("<br/>Please chill down this can of milk immediately.")
                                .pauseFor(250)
                                .typeString("<br />After that - ")
                                .pauseFor(250)
                                .typeString("per the terms of this engagement - ")
                                .pauseFor(250)
                                .typeString("please leave your completely honest 100% no-glaze review of the world's first can of milk.")
                                .pauseFor(500)
                                .typeString("<br />Then, ")
                                .pauseFor(250)
                                .typeString("please consider repurchasing Cow Juice.")
                                .pauseFor(500)
                                .callFunction(() => {
                                    setIsTextTyping();
                                })
                                .start();
                        }} 
                    />
                </a>
            </div>
        </div>
       
    );
};

export default Card;